import {TextAlignment} from 'pdf-lib';

import {environment} from '@shared-types';

/**
 * Enum for text alignments.
 * @enum {number}
 */
export enum Alignments {
	/**
	 * Left alignment.
	 */
	Left = 0,

	/**
	 * Center alignment.
	 */
	Center = 1,

	/**
	 * Right alignment.
	 */
	Right = 2,
}
/* -------------------------------------------------------------------------------------------------------------- */
/**
 * Object mapping Alignments enum to string values.
 * @const {Object}
 */
export const TextAlignmentType = {
	/**
	 * Mapping for left alignment.
	 */
	[Alignments.Left]: 'left',

	/**
	 * Mapping for center alignment.
	 */
	[Alignments.Center]: 'center',

	/**
	 * Mapping for right alignment.
	 */
	[Alignments.Right]: 'right',
} as const;

/**
 * Type definition for TextAlignmentType.
 * @typedef {string}
 */
export type TextAlignmentType = (typeof TextAlignmentType)[keyof typeof TextAlignmentType];
/* -------------------------------------------------------------------------------------------------------------- */
/**
 * Function to get text alignment based on value.
 * @param {Alignments | TextAlignment} value - The value to determine alignment.
 * @returns {'left' | 'center' | 'right'} - The text alignment.
 */
export function getTextAlignment(value: Alignments | TextAlignment): TextAlignmentType {
	switch (value) {
		case Alignments.Left:
			return 'left';
		case Alignments.Center:
			return 'center';
		case Alignments.Right:
			return 'right';
	}
	return environment?.direction === 'rtl' ? 'right' : 'left';
}
